module.exports = __webpack_public_path__ + "static/img/timesUp.9e558a06.png";